import Right from '@assets/icons/right.svg'
import { Icon } from './Icon'

export const RightIcon = Icon(Right)
